/**
 * Feature flag enum matching Cockpit's FeatureFlag enum.
 * String values must match Unleash toggle names exactly.
 *
 * Source: services/core/cockpit/src/types.ts
 */
export enum FeatureFlag {
    F_GPT_IMPORTS = 'F_GPT_IMPORTS',
    F_GPT_RENTAL_CONTRACT = 'F_GPT_RENTAL_CONTRACT',
    F_CAPEX_CALCULATOR = 'F_CAPEX_CALCULATOR',
    F_NETSUITE_INVOICE_EXPORT = 'F_NETSUITE_INVOICE_EXPORT',
    F_MFH_RENOVATION_PROJECT = 'F_MFH_RENOVATION_PROJECT',
    F_MFH_IC_USE_ORIGINAL_CASE = 'F_MFH_IC_USE_ORIGINAL_CASE',
    F_MILESTONE_REPORTING = 'F_MILESTONE_REPORTING',
    F_LOG_RECENT_PAGES = 'F_LOG_RECENT_PAGES',
    F_PREFLIGHT_TELEMETRY = 'F_PREFLIGHT_TELEMETRY',
    F_USE_EMAIL_PASS_AUTH = 'F_USE_EMAIL_PASS_AUTH',
    F_SHOW_SIGN_OFF_EXTERNAL = 'F_SHOW_SIGN_OFF_EXTERNAL',
    F_ESTARCORE_IMPORT_ENABLED = 'F_ESTARCORE_IMPORT_ENABLED',
    F_USE_MFH_MAP_FEATURE = 'F_USE_MFH_MAP_FEATURE',
    F_MFH_ASSET_MANAGEMENT_IC = 'F_MFH_ASSET_MANAGEMENT_IC',
    F_DOC_RECLASSIFIER = 'F_DOC_RECLASSIFIER',
    F_TENDER_MANAGEMENT = 'F_TENDER_MANAGEMENT',
    F_IC_SENSITIVITY = 'F_IC_SENSITIVITY',
    F_COPILOTKIT_INSPECTOR = 'F_COPILOTKIT_INSPECTOR',
    F_AI_HUB = 'F_AI_HUB',
    F_ENABLE_MASTRA_STUDIO = 'F_ENABLE_MASTRA_STUDIO',
    F_CHANGE_LANGUAGE_ENABLED = 'F_CHANGE_LANGUAGE_ENABLED',
}
